import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    FieldBox: styled.div `
    position: relative;

    display: flex;
    flex-wrap: ${(props) => (props.isFull ? 'wrap' : 'no-wrap')};
    align-items: center;

    width: 100%;
    min-height: 53px;
    padding: 7px 14px 7px 16px;
    margin-bottom: 12px;

    background: ${(props) => props.isError
        ? SEMANTIC_COLORS.ERROR_FIELD_BOX_BACKGROUND
        : SEMANTIC_COLORS.DEFAULT_FIELD_BOX_BACKGROUND};
    border-radius: 10px;
  `,
    FieldTitle: styled.label `
    flex-shrink: 0;
    align-self: start;

    padding: 8px 0;

    font-size: 18px;
    font-weight: 500;
    color: ${(props) => props.isError ? SEMANTIC_COLORS.ERROR_TITLE : SEMANTIC_COLORS.DEFAULT_TITLE};
  `,
    InputText: styled.input `
    width: ${(props) => (props.isFull ? '100%' : '120px')};
    height: 39px;
    padding-right: 12px;
    padding-bottom: 5px;
    padding-left: ${(props) => (props.isFull || props.align === 'left' ? '15px' : '0')};
    margin-right: ${(props) => (props.isFull || props.align === 'left' ? '0' : '8px')};

    font-size: 18px;
    text-align: ${(props) => (props.isFull || props.align === 'left' ? 'left' : 'right')};
    background: ${SEMANTIC_COLORS.DEFAULT_INPUT_BACKGROUND};
    border: none;
    border-radius: 16px;
    opacity: 0.7;

    &:focus {
      outline: none;
    }
  `,
    Unit: styled.span `
    margin: 0 12px 3px 0;

    font-size: 18px;
    line-height: 26px;
    color: ${SEMANTIC_COLORS.COMMENT_TEXT};
  `,
    FeedbackErrorText: styled.div `
    margin: -12px 0 12px;

    font-size: 16px;
    line-height: 23px;
    color: ${SEMANTIC_COLORS.ERROR_TEXT};
  `,
};
